import Base from './Base';

class Text extends Base {
  constructor(...args) {
    super(...args);
    this.inputType = 'text';
  }
}
export default Text;



// WEBPACK FOOTER //
// ./src/components/Form/Input/Text.js